export const hero = {
  "title": "Ruil tussen hosts,",
  "titleHighlight": "overal in Europa",
  "subtitle": "Europese ruilclub exclusief voor Airbnb-hosts met een 4,5+ beoordeling en een uniek Europa-abonnement.",
  "cta": "Start de ruil",
  "learnMore": "Meer weten",
  "stats": {
    "owners": "Actieve eigenaars",
    "countries": "Beschikbare landen",
    "exchanges": "Voltooide ruilen"
  },
  "slogans": {
    "slogan1": {
      "title": "Privéclub",
      "highlight": "Airbnb-hosts 4,5+",
      "subtitle": "Toegang gereserveerd voor hooggewaardeerde hosts om in vertrouwen te ruilen."
    },
    "slogan2": {
      "title": "Lanceeraanbieding 2026",
      "highlight": "-50% voor de eerste 1000",
      "subtitle": "25EUR/jaar in plaats van 50EUR/jaar, met levenslange prijsgarantie."
    },
    "slogan3": {
      "title": "Levenslange prijsgarantie",
      "highlight": "Eerste 1000 leden",
      "subtitle": "De eerste 1000 inschrijvingen behouden hun tarief voor het leven."
    },
    "slogan4": {
      "title": "Geen tussenpersonen,",
      "highlight": "alleen verbinding",
      "subtitle": "Een vertrouwde gemeenschap waar verblijven worden geruild, geen nachten verkocht."
    },
    "slogan5": {
      "title": "Word lid van de club",
      "highlight": "DONKEY TRAVEL",
      "subtitle": "De ruilclub ontworpen voor actieve Airbnb-hosts in Europa."
    },
    "slogan6": {
      "title": "Laagseizoen",
      "highlight": "geoptimaliseerd",
      "subtitle": "Verander uw rustige periodes in reismogelijkheden."
    },
    "slogan7": {
      "title": "Neem een pauze,",
      "highlight": "vermijd burn-out",
      "subtitle": "Kom op adem tussen twee verhuurperiodes door uw woning te ruilen."
    },
    "slogan8": {
      "title": "De reisgeest,",
      "highlight": "de echte",
      "subtitle": "Ontmoet andere hosts en ontdek nieuwe plekken tegen lagere kosten."
    },
    "slogan9": {
      "title": "100% Gemaakt in Frankrijk",
      "highlight": "(Picardië)",
      "subtitle": "Niet Silicon Valley, maar de Haute Somme-vallei. Een ambachtelijk platform, menselijk en trots op zijn wortels."
    }
  }
};
